import React, { useState } from "react";
import { Button, TextField, Box } from "@material-ui/core";
import ServiceAPI from "../../../../service/ServiceAPI";
import InventoryGalleryModel from "../../../../model/InventoryGalleryModel";
import { makeStyles } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import InventoryImage from "../../../utils/InventoryImage";

const useStyles = makeStyles({
  container: {
    width: '300px',
    height: '100%',
    margin: '1em auto',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'space-between',
    justifyContent: 'space-between'
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between'
  }
});

const EditImageView = function(props) {
  console.assert(props.workflowViews);
  console.assert(props.setWorkflowView);
  console.assert(props.selectedImage);
  
  const cssClasses = useStyles();

  const [imageBase64, setImageBase64] = useState(props.selectedImage.image);
  const [description, setDescription] = useState(props.selectedImage.description);
 
  /**
   * Uploads the image to the API
   */
  const handleClick_updateImage = () => {
    let image = new InventoryGalleryModel();
    image.setId(props.selectedImage.id);
    image.setDescription(description);
        
    ServiceAPI.InventoryGallery().updateImage(image).then( (data) => {
      props.setWorkflowView(props.workflowViews.Gallery);
    });
  }

  const render = () => {
    return (
      <Box className={cssClasses.container}>
        <h3>Edit image in the Gallery</h3>
        <InventoryImage base64Image={imageBase64} alt={description} />
        <TextField 
          value={description} 
          onChange={(e) => setDescription(e.currentTarget.value)} 
          label="Image description" 
          variant="outlined"/
        >
        <Box className={cssClasses.actions}>
          <Button variant="contained" color="default" size="large" startIcon={<CloseIcon />} onClick={() => props.setWorkflowView(props.workflowViews.Gallery) }>
            Cancel
          </Button>

          <Button variant="contained" color="primary" size="large" startIcon={<EditIcon />} onClick={handleClick_updateImage}>
            Update
          </Button>
        </Box>
      </Box>
    );
  }

  return render();
}

export default EditImageView; 